export interface ApiError {
  code: string;
  message: string;
  details?: Record<string, unknown>;
}

export interface ApiErrorEnvelope {
  error: ApiError;
}

export function extractApiError(httpErrorBody: unknown): ApiError | null {
  const body = httpErrorBody as Partial<ApiErrorEnvelope> | null;
  return body?.error ?? null;
}
